import React from "react";
import { getArrears } from "./util";
import { CircleContentContainer } from "./circleContentContainer";
import { AccountTitle } from "./accountTitle";
import { AccountSeparator } from "./accountSeparator";
import { AccountDetails } from "./accountDetails";
import { label } from "./constants";
import CircularProgress from "../circularProgress/circularProgress";
import PropTypes from "prop-types";

export const AccountWidget = ({ account, style, children }) => {
  const arrears = getArrears(account);

  return (
    <CircleContentContainer style={style} arrears={arrears} accountDescription={account.accountDescription} accountType={account.accountType}>
      <CircularProgress
        percent={account.paymentPercentages.repaid}
        label={label}
        account={account}
      />
      <AccountTitle accountNumber={account.accountNumber} arrears={arrears} />
      <AccountSeparator arrears={arrears} />
      <AccountDetails arrears={arrears} label={label} account={account} />
      {children}
    </CircleContentContainer>
  );
};

AccountWidget.propTypes = {
  account: PropTypes.any.isRequired,
  style: PropTypes.object,
  children: PropTypes.node,
};

AccountWidget.defaultProps = {
  style: undefined,
  children: undefined,
};
